import React, { Fragment } from "react";

import Backdrop from "../Backdrop/Backdrop";
import MessageModal from "./MessageModal/MessageModal";
import "./MessageHandler.css";

const MessageHandler = (props) => (
  <Fragment>
    {props.showMessage && <Backdrop onClick={props.onHandle} />}
    {props.showMessage && (
      <MessageModal
        onCancelModal={props.onCancelModal}
        onAcceptModal={props.onAcceptModal}
        acceptEnabled
        acceptMessage={props.acceptMessage}
        cancelMessage={props.cancelMessage}
      >
        <p className="mn-Message__handler">{props.message}</p>
      </MessageModal>
    )}
  </Fragment>
);

export default MessageHandler;
